import { render, staticRenderFns } from "./mobilehead.vue?vue&type=template&id=e12b17d8&scoped=true&"
import script from "./mobilehead.vue?vue&type=script&lang=js&"
export * from "./mobilehead.vue?vue&type=script&lang=js&"
import style0 from "./mobilehead.vue?vue&type=style&index=0&id=e12b17d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12b17d8",
  null
  
)

export default component.exports